import React from 'react';
import { Phone, MessageSquare, Clock } from 'lucide-react';
import CallMetricsCard from '../components/CallMetricsCard';
import ActiveCallsList from '../components/ActiveCallsList';
import { useCall } from '../context/CallContext';

export default function Dashboard() {
  const { metrics, calls } = useCall();

  return (
    <div className="p-6 space-y-6">
      <header>
        <h1 className="text-2xl font-bold text-gray-900">Översikt</h1>
        <p className="text-gray-600">Övervaka dina AI-kommunikationsstatistik</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <CallMetricsCard
          icon={<Phone className="h-6 w-6 text-green-600" />}
          title="Totalt antal samtal"
          value={metrics.totalCalls.toString()}
          change="+12.5%"
          isPositive={true}
        />
        <CallMetricsCard
          icon={<MessageSquare className="h-6 w-6 text-blue-600" />}
          title="Genomsnittlig samtalstid"
          value={metrics.averageDuration}
          change="-1.2%"
          isPositive={false}
        />
        <CallMetricsCard
          icon={<Clock className="h-6 w-6 text-purple-600" />}
          title="Svarstid"
          value={metrics.responseTime}
          change="+5.3%"
          isPositive={true}
        />
      </div>

      <ActiveCallsList />

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Senaste samtal</h2>
        <div className="space-y-4">
          {calls.slice(0, 3).map((call) => (
            <div key={call.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <div className="flex items-center space-x-4">
                <div className="p-2 bg-indigo-100 rounded-full">
                  <Phone className="h-5 w-5 text-indigo-600" />
                </div>
                <div>
                  <p className="font-medium text-gray-900">{call.phoneNumber}</p>
                  <p className="text-sm text-gray-500">Längd: {call.duration}</p>
                </div>
              </div>
              <span className="text-sm text-gray-500">{call.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}